//      
                                                                       

export default (descriptor                     )                    => ({
  index: descriptor.index,
  droppableId: descriptor.droppableId,
});



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/get-home-location.js